import {
  alpha,
  Box,
  Button,
  InputBase,
  Paper,
  styled,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import DataTableComponent from "../../../components/common/DataTable/DataTable";
import {
  generateTopUpHistoryColumns,
  generateFundWalletColumns,
  generatePromoCodeColumns,
  generateReferralCampaignColumns,
} from "../helper";
import PageHeader from "../../../components/PageHeader";
import SidebarContext from "../../../context/SidebarContext";
import { getCampaigns } from "../../../helper/campaign";
import { useDispatch, useSelector } from "react-redux";
import { setCampaigns } from "../../../store/campaign";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px",
  backgroundColor: "#FAFAFA",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  // width: "230px",
  height: "40px",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(1),
    // width: "auto",
  },
  border: "1px solid #EEEEEE",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "230px",
    // [theme.breakpoints.up("sm")]: {
    //   width: "12ch",
    //   "&:focus": {
    //     width: "20ch",
    //   },
    // },
  },
}));

function TopUpHistoryTable({ setAddFundDrawer, addFundDrawer }) {
  const dispatch = useDispatch();
  const { open } = useContext(SidebarContext);
  const [searchValue, setSearchValue] = useState("");
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getColumns = () => {
    switch (tabValue) {
      case 0:
        return generateTopUpHistoryColumns();
      case 1:
        return generateFundWalletColumns();
      case 2:
        return generatePromoCodeColumns();
      case 3:
        return generateReferralCampaignColumns();
      default:
        return generateTopUpHistoryColumns();
    }
  };

  const toUpColumns = getColumns();
  // const [campaignData, setCampaignData] = useState([]);
  const campaigns = useSelector((state) => state.campaign.campaigns);

  useEffect(() => {
    const getAllCampaigns = async () => {
      const response = await getCampaigns();
      console.log(response, "responsedasfsdf");
      dispatch(setCampaigns(response));
      // setCampaignData(response);
    };
    getAllCampaigns();
  }, []);

  const filteredRows = campaigns?.filter((row) => {
    if (!searchValue) return true;
    const term = searchValue.toLowerCase();

    // Check if any email object contains the search term in its email string
    const emailMatch = row?.emails?.some((e) =>
      e?.email?.toLowerCase()?.includes(term),
    );

    // You can also add other search criteria like campaignType or amount here if needed
    const typeMatch = row?.campaignType?.toLowerCase()?.includes(term);

    return emailMatch || typeMatch;
  });

  const tabFilteredRows = filteredRows?.filter((row) => {
    if (tabValue === 0) return true;
    if (tabValue === 1) return row?.campaignType === "fund_wallet";
    if (tabValue === 2) return row?.campaignType === "promo_code";
    if (tabValue === 3) return row?.campaignType === "referral_campaign";
    return true;
  });

  console.log(tabFilteredRows, "dfsdfdf");

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ p: "24px 16px", paddingLeft: "0px" }}>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Search>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(94, 23, 235, 1)",
                color: "white",
                border: "1px solid rgba(94, 23, 235, 1)",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "white",
                  backgroundColor: "rgba(94, 23, 235, 1)", // Remove border color on focus
                },
              }}
              onClick={() => setAddFundDrawer(true)}
            >
              Add Fund
            </Button>
          </Box>
        </Box>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, px: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="campaign tabs"
          sx={{
            "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
            "& .Mui-selected": { color: "rgba(94, 23, 235, 1) !important" },
            "& .MuiTabs-indicator": { backgroundColor: "rgba(94, 23, 235, 1)" },
          }}
        >
          <Tab label="All" />
          <Tab label="Fund Wallet" />
          <Tab label="Promo Code" />
          <Tab label="Referral Campaign" />
        </Tabs>
      </Box>

      {tabFilteredRows?.length > 0 && (
        <Box sx={{ display: "contents" }}>
          <Paper
            sx={{
              width: "100%",
              // height: "75vh",
              border: "1px solid #E5E5E8",
              borderRadius: "4px",
            }}
          >
            <DataTableComponent
              data={tabFilteredRows || []}
              columns={toUpColumns}
              // searchHandler={searchHandler}
              // paginationHandler={paginationHandler}
              // pagination={pagination}
            />
          </Paper>
        </Box>
      )}
      {tabFilteredRows && tabFilteredRows.length <= 0 && (
        <Box sx={{ marginTop: "10%" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {/* <img src={issue} alt="issue_not_found" /> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
              No records found
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography>Try different keyword</Typography>
          </Box>
        </Box>
      )}
    </>
  );
}

export default TopUpHistoryTable;
